module.exports = __webpack_public_path__ + "static/media/andes-2560.3ddd0de6.webp";